import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
import PerkboxToken from "../../utils/PerkboxToken";
import Tiers from "../../enums/medicalTiers";
var buildTiers = function (accessToken) {
    var decoded = new PerkboxToken(accessToken);
    var tiers = decoded.getRestrictions(tiersQuery);
    if (!Array.isArray(tiers)) {
        return false;
    }
    return {
        tier1: tiers.find(function (tier) { return tier === Tiers.TIER1; }),
        tier2: tiers.find(function (tier) { return tier === Tiers.TIER2; }),
        tier3: tiers.find(function (tier) { return tier === Tiers.TIER3; })
    };
};
var tiersQuery = {
    service: "medical",
    resource: "tiers",
    action: "read",
    restriction: "tier"
};
export default {
    get: function (token) {
        var medical = getPermissions(token, "medical", ["accounts"], ["read", "create"]);
        var reports = medical && getPermissions(token, "medical", ["activation"], ["read"]);
        var tiers = buildTiers(token.myToken);
        var permissions = {
            medical: medical,
            reports: reports,
            tiers: omitEmpty(tiers)
        };
        return omitEmpty(permissions);
    }
};
